<template>
  <div class="container-fluid">

    <h5>گزارش ضایعات تولید در کل شرکت</h5>

    <b-tabs justified
            active-nav-item-class="font-weight-bold text-success"
            active-tab-class="font-weight-bold"
            content-class=""
            class="mt-3"
    >
      <!--------first tab------->
      <b-tab title="ضایعات حال حاضر کل کارگاهها" active>
        <div v-if="isLoading">
          <Preloader/>
        </div>
        <div v-else>
          <div class="row my-4">
            <div class="col-12 mt-3" v-if="nodata">
              <h3>
                در حال حاضر هیچ ضایعاتی در کل شرکت گزارش نشده است.
              </h3>
            </div>
            <div class="col-12 mt-3" v-else>
              <table class="table table-striped">
                <thead>
                <tr>
                  <th scope="col" class="text-center">نام محصول</th>
                  <th scope="col" class="text-center">نام کارگاه</th>
                  <th scope="col" class="text-center">نوع ضایعات</th>
                  <th scope="col" class="text-center">شرح ضایعات</th>
                  <th scope="col" class="text-center">تعداد</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in currentdamages">
                  <td class="text-center">{{item.product.productName}}</td>
                  <td class="text-center">{{item.company.companyName}}</td>
                  <td class="text-center">{{item.damageType.name}}</td>
                  <td class="text-center">{{item.description}}</td>
                  <td class="text-center">{{item.value}}</td>

                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </b-tab>
      <!--------first tab------->
      <b-tab title="گزارش بر اساس نوع ضایعات">
        <div class="row my-4">
          <!--<div class="col-12 mt-3" v-if="nodata1">-->
            <!--<h3>-->
              <!--هیچ ضایعاتی در کل شرکت گزارش نشده است.-->
            <!--</h3>-->
          <!--</div>-->
          <div class="col-12 mt-3"  >
            <div class="col-12 mt-3 d-inline-flex">
              <div class="col-6">
                <div class="input-group">
                  <div class="input-group-prepend custom">
                    <div class="input-group-text">
                      <span>نوع ضایعات : </span>
                    </div>
                  </div>
                  <vs-select
                    ref="selectedProgram"
                    :isHeader="true"
                    :data="damageTypes"
                    :selectedVal="damageTypes.id"
                    :header="{label:'name'}"
                    :mode="'edit'"
                    @dataChanged="damageTypeSelect"
                    aria-placeholder="لطفا نوع ضایعات را انتخاب کنید"
                  ></vs-select>
                  <!--v-bind:class="{ 'hover-pointer': mode!=='view' }"-->
                </div>
              </div>

            </div>
            <div class="col-12 mt-3">
              <table class="table table-striped">
                <thead>
                <tr>
                  <th scope="col" class="text-center">نام محصول</th>
                  <th scope="col" class="text-center">نام کارگاه</th>
                  <th scope="col" class="text-center">نوع ضایعات</th>
                  <th scope="col" class="text-center">شرح ضایعات</th>
                  <th scope="col" class="text-center">تعداد</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in currentdamages">
                  <td class="text-center">{{item.product.productName}}</td>
                  <td class="text-center">{{item.company.companyName}}</td>
                  <td class="text-center">{{item.damageType.name}}</td>
                  <td class="text-center">{{item.description}}</td>
                  <td class="text-center">{{item.value}}</td>

                </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>
      </b-tab>

      <!--------first tab------->
      <!--<b-tab title="گزارش بر اساس نوع ضایعات">-->
        <!--<div class="row my-4">-->
          <!--&lt;!&ndash;<div class="col-12 mt-3" v-if="nodata2">&ndash;&gt;-->
          <!--&lt;!&ndash;<h3>&ndash;&gt;-->
          <!--&lt;!&ndash;هیچ ضایعاتی در کل شرکت گزارش نشده است.&ndash;&gt;-->
          <!--&lt;!&ndash;</h3>&ndash;&gt;-->
          <!--&lt;!&ndash;</div>&ndash;&gt;-->
          <!--&lt;!&ndash;<div class="col-12 mt-3" v-else>&ndash;&gt;-->

          <!--<div class="col-lg-12 col-sm-12 my-2">-->
            <!--<div class="card shadow text-white  mb-1">-->
              <!--<div class="card-body pb-0">-->
                <!--<div class="card-chart">-->
                  <!--<canvas id="barchart1" width="1000" height="555"></canvas>-->
                <!--</div>-->
              <!--</div>-->
            <!--</div>-->
          <!--</div>-->

        <!--</div>-->

        <!--&lt;!&ndash;</div>&ndash;&gt;-->
      <!--</b-tab>-->

      <!--------first tab------->
      <!--<b-tab title="گزارش بر اساس زمان ضایعات">-->
        <!--<div class="row my-4">-->
          <!--&lt;!&ndash;<div class="col-12 mt-3" v-if="nodata2">&ndash;&gt;-->
          <!--&lt;!&ndash;<h3>&ndash;&gt;-->
          <!--&lt;!&ndash;هیچ ضایعاتی در کل شرکت گزارش نشده است.&ndash;&gt;-->
          <!--&lt;!&ndash;</h3>&ndash;&gt;-->
          <!--&lt;!&ndash;</div>&ndash;&gt;-->
          <!--&lt;!&ndash;<div class="col-12 mt-3" v-else>&ndash;&gt;-->

          <!--<div class="col-lg-12 col-sm-12 my-2">-->
            <!--<div class="card shadow text-white  mb-1">-->
              <!--<div class="card-body pb-0">-->
                <!--<div class="card-chart">-->
                  <!--<canvas id="barchart3" width="1000" height="555"></canvas>-->
                <!--</div>-->
              <!--</div>-->
            <!--</div>-->
          <!--</div>-->

        <!--</div>-->

        <!--&lt;!&ndash;</div>&ndash;&gt;-->
      <!--</b-tab>-->

    </b-tabs>

    <!-------------------------------------------------------------------------------->

  </div>
</template>

<script>
  import VsTable from "../../_framework/VsTable.vue";
  import BaseService from "../../_framework/api/BaseService.js";
  import {mapState, mapMutations, mapActions} from "vuex";
  import Vue from "vue";
  import Products from "../Products.vue";
  import chart from "chart.js";
  import VsSelect from "../../_framework/VsSelect";
  // import ShowdamagesModal from "../../components/ShowdamagesModal";
  // import damageDetails from "../../components/damageDetails.vue";
  import DatePicker from "../../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue";
  import Utils from "../../_framework/utils/Utils";
  import Moment from "moment-jalali";
  import VsTableHeaderRow from "../../_framework/VsTableHeaderRow";


  export default {
    name: "workreport-damage",
    created: () => {
    },
    components: {
      VsTableHeaderRow,
      VsTable,
      Products,
      VsSelect,
    },
    data() {
      return {
        isLoading: false,
        bar_chart: "bar-chart",
        show: true,
        nodata: true,
        nodata1: true,
        nodata2: true,
        access: {},
        products: {},
        productQuantity: {},
        productName: "",
        unitName: "",
        productId: "",
        rawproductQuantity: {},
        rawproducts: {},
        backgroundColor: ["#facf5a8f", "#ff59598f", "#49beb78f", "#a374d58f", "#5d99c68f", "#9cf1968f"],
        hoverBackgroundColor: ['#facf5ab5', '#ff5959b5', '#49beb7b5', '#a374d5b5', '#5d99c6b5', '#9cf196b5'],
        currentdamages: {},
        totaldamages: {},
        typedamages: {},
        damageTypes: [],
        damageDetails: [],
        selecteddamageType: 0,
        selecteddamageId: 0,
        damageNameChart: [],
        damageTime: [],


      };
    },
    beforeMount() {
      this.getcurrentdamages();
      this.gettotaldamages();
      this.getdamageTypes();

      this.isLoading = true;
      new BaseService('WorksReports', '/GetTotaldamageWorksChart').getList().then((response) => {
        this.isLoading = false;
        if (response.data === null) {
          this.nodata2 = true;
        } else {
          this.nodata2 = false;
          this.typedamages = response.data;

          this.gettypedamages();
        }
      }).catch((error) => {
        this.isLoading = false;
        console.log(error)
      });
    },
    methods: {
      getcurrentdamages() {
        new BaseService('WorksReports', '/GetDamageWorks').getList().then((response) => {
          if (response.data === null) {
            this.nodata = true;
          } else {
            this.nodata = false;
            this.currentdamages = response.data.value;
          }
        }).catch((error) => {
          console.log(error)
        });
      },
      gettotaldamages() {
        new BaseService('WorksReports', '/GetTotaldamageWorks').getList().then((response) => {
          if (response.data === null) {
            this.nodata1 = true;
          } else {
            this.nodata1 = false;
            this.totaldamages = response.data;


          }
        }).catch((error) => {
          console.log(error)
        });
      },
      getSelecteddamages(id) {
        new BaseService('WorksReports', '/GetSelecteddamageWorks/' + id).getList().then((response) => {
          if (response.data === null) {
            this.nodata1 = true;
          } else {
            this.nodata1 = false;
            this.totaldamages = response.data;


          }
        }).catch((error) => {
          console.log(error)
        });
      },
      hideModal() {
        this.$refs.selectProductModal.hide();
      },
      getdamageTypes() {
        new BaseService('Workproblems', '/GetDamageTypes').getList().then((response) => {
          // console.log(response.data);
          this.damageTypes = response.data;

        }).catch((error) => {
          console.log(error)
        })
      },
      getdamages(id) {
        new BaseService('WorksReports', '/GetSelectedDamgeWorks/' + id).getList().then((response) => {
          // console.log(response.data);
          this.currentdamages =[];
          if (response.data === null) {
            this.nodata = true;
          } else {
            this.nodata = false;
            this.currentdamages = response.data.value;
          }
        }).catch((error) => {
          console.log(error)
        })
      },
      damageTypeSelect(prop, data) {
        console.log(data);
        // console.log(data.programId);

        if (data === null) {
          this.getcurrentdamages();
        } else {
          this.selecteddamageType = data.id;
          this.getdamages(data.id);
        }
      },
      damageSelect(prop, data) {
        // console.log(data);
        // console.log(data.programId);
        this.selecteddamageId = data.id;
        this.getSelecteddamages(data.id);
      },


      gettypedamages() {

        var dataName = [];
        var dataCompany = [];
        var dataHours = [];
        var dataCount = [];
        for (let damage of this.typedamages) {
          this.damageNameChart.push(damage.damageName);
          dataName.push(damage.damageDescription);
          dataCompany.push(damage.totalCompany);
          dataHours.push(damage.totalHoursInStatus);
          dataCount.push(damage.totalCount);
        }

        Chart.defaults.global.defaultFontFamily = 'shabnam';
        this.polar = new Chart(document.getElementById("barchart1").getContext('2d'), {

          type: 'bar',
          data: {
            labels: dataName,
            datasets: [
              {
                label: 'تعداد کارگاه',
                data: dataCompany,
                backgroundColor: 'rgba(255,193,7,0.71)',
                borderColor: "rgba(255,143,0,0.71)"
              },
              {
                label: 'تعداد کار',
                data: dataCount,
                backgroundColor: 'rgba(249,60,103,0.71)',
                borderColor: "rgba(198,40,40,0.71)"
              },
              // {
              //   label: 'ساعات ضایعات',
              //   data: dataHours,
              //   backgroundColor: 'rgba(205,220,57,0.71)',
              //   borderColor: "rgba(135,150,40,0.71)"
              // }
            ]
          },
          options: {
            scales: {
              xAxes: [{
                stacked: true
              }],
              yAxes: [{
                stacked: true
              }]
            },
            fill: {
              type: 'gradient',
              gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.7,
                opacityTo: 0.9,
                stops: [0, 90, 100]
              }
            },
            title: {
              display: true,
              text: 'ضایعات تولید'
            },
          }

        });

        Chart.defaults.global.defaultFontFamily = 'shabnam';
        this.polar = new Chart(document.getElementById("barchart3").getContext('2d'), {

          type: 'bar',
          data: {
            labels: dataName,
            datasets: [
              {
                label: 'تعداد کارگاه',
                data: dataCompany,
                backgroundColor: 'rgba(255,193,7,0.71)',
                borderColor: "rgba(255,143,0,0.71)"
              },
              // {
              //   label: 'تعداد کار',
              //   data: dataCount,
              //   backgroundColor: 'rgba(249,60,103,0.71)',
              //   borderColor: "rgba(198,40,40,0.71)"
              // },
              {
                label: 'ساعات ضایعات',
                data: dataHours,
                backgroundColor: 'rgba(249,60,103,0.71)',
                borderColor: "rgba(198,40,40,0.71)"
              }
            ]
          },
          options: {
            scales: {
              xAxes: [{
                stacked: true
              }],
              yAxes: [{
                stacked: true
              }]
            },
            fill: {
              type: 'gradient',
              gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.7,
                opacityTo: 0.9,
                stops: [0, 90, 100]
              }
            },
            title: {
              display: true,
              text: 'مجموع ساعات ضایعات'
            },
          }

        });


      },


    },
    computed: {
      ...mapState(["vsTableFeed", "tableRowIndex"])
    }
  };
</script>
